import { useRef, useEffect, useState } from "react";
import { HeroBackground } from "./Hero/HeroBackground";
import { HeroContent } from "./Hero/HeroContent";
import { ScrollIndicator } from "./Hero/ScrollIndicator";

export const Hero = () => {
  const heroRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight - 80,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`relative min-h-screen flex items-center justify-center overflow-hidden transition-all duration-1000 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
      ref={heroRef}
    >
      {/* Background Pattern */}
      <HeroBackground />

      {/* Content */}
      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <HeroContent />
        </div>
      </div>

      <ScrollIndicator onClick={scrollToContent} />
    </div>
  );
};
